import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, allowedRoles = [], ownerOnly = false, staffOnly = false }) => {
  const { isAuthenticated, user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="loading"></div>
      </div>
    );
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // Check role-based access
  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.role)) {
    // Redirect based on user role
    if (user?.role === 'owner') {
      return <Navigate to="/dashboard" replace />;
    } else {
      return <Navigate to="/staff-dashboard" replace />;
    }
  }

  // Check owner-only routes
  if (ownerOnly && user?.role !== 'owner') {
    return <Navigate to="/staff-dashboard" replace />;
  }

  // Check staff-only routes
  if (staffOnly && user?.role !== 'staff') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;